/* eslint-disable max-lines-per-function */
import React, { FC, useEffect, useState } from 'react';
import styles from './Breadcrumb.module.scss';
import useScrollCheck from './useScrollCheck';
import Row from '../ResponsiveRow/row';
import { BREADCRUMB } from '../../utils/constants';
import { LineTableBasicPropConfig } from '../../services/LineTableBasicPropConfig';
import { CMSStoryblokServiceV2 } from '@sunrise-upc/ajax-lib';

const Breadcrumb:FC<any> = ({content: _content,metadata,startString}): any => {
  const fullSlugName = metadata?.full_slug?.split('/');
  const sbEndpoint = LineTableBasicPropConfig?.getInstance()?.getSBUrl();

  if (metadata?.full_slug?.substr(-1) === '/') {
    fullSlugName.pop();
  } else {
    metadata?.full_slug?.split('/');
  }
  const pathArray = fullSlugName?.map((path: any, i: number) => {
    return { breadcrumb: path, href: fullSlugName?.slice(0, i + 1)?.join('/') + '/' };
  });

  pathArray[pathArray?.length - 1].href =
  metadata?.full_slug?.substr(-1) === '/'
      ? pathArray[pathArray.length - 1].href
      : pathArray[pathArray.length - 1].href?.substr(
          0,
          pathArray[pathArray?.length - 1].href?.length - 1
        );
  const lang=metadata?.lang;
  const [finalPathArray, setFinalPathArray] = useState<any>([]);
  const [dropdownStatus, setDropdownStatus] = useState<boolean>(false);
  const breadcrumbSeparator = '/ecom-int/icons/arrow_sign.svg';
  const startStringg = startString?startString:'';
  const { isScrollBreak } = useScrollCheck();
  const lastPathIndex = finalPathArray?.length > 1 ? finalPathArray?.length - 1 : 0;
  const mobDropDownArr: any[] = [...finalPathArray];
  const slicedMobArr = mobDropDownArr?.slice(1, -1);
  const dataSourceFetch = async () => {
    const sample: any = [];
    const hrefArray: any = [];
    pathArray.map(async (item: any) => {
      hrefArray.push(item.href);
    });

    let story;
    const urllll = sbEndpoint + `rest/cms/stories?by_slugs=${hrefArray.join()}`;
    story = await CMSStoryblokServiceV2.get(urllll, {
      type: 'B2C',
      version: 'published',
      language: lang,
      per_page: 10,
      sort_by: 'slug:asc'
    });
    story?.data?.stories?.map((item: any) => {
      const bodyContent = item.content.body;
      const slugName = item.full_slug.split('/');
      let breadcrumbName = '';
      bodyContent.map((ele: any) => {
        if (ele.component === 'breadcrumb') {
          breadcrumbName = ele.breadcrumbName;
        }
      });
      if (item.full_slug.substr(-1) === '/') {
        slugName.pop();
      } else {
        item.full_slug.split('/');
      }
      let path: string | undefined = item?.full_slug?.endsWith('/')
        ? item?.full_slug?.slice(0, -1)
        : item?.full_slug;
      const pathUrl = path?.replace(startStringg, '');
      sample.push({
        breadcrumb: breadcrumbName ? breadcrumbName : slugName[slugName.length - 1],
        href: '/' + pathUrl
      });
    });
    setFinalPathArray(sample);
  };

  useEffect(() => {
    dataSourceFetch();
  }, []);
  const [dropdownWidth, setdropdownWidth] = useState<number>(0);
  let dropdownWidthEle: any;
  const handleResize = () => {
    const screenSize = window.innerWidth;
    if (screenSize < 1024) {
      dropdownWidthEle = document.getElementById('firstBreadcrumb');
      setdropdownWidth(dropdownWidthEle?.offsetWidth);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
  }, [dropdownStatus]);

  const handleDropdown = () => {
    setDropdownStatus(!dropdownStatus);
  };
  useEffect(() => {
    setDropdownStatus(false);
  }, [isScrollBreak]);

  return (
    <div className={styles.outer}>
      <Row>
        <div className={`breadcrumb-section ${styles['breadcrumb-container']}`}>
          {/* Mobile view */}
          <span className={'d-block d-md-none'}>
            {finalPathArray && finalPathArray.length > 1 && (
              <span className={`${styles['link']}`}>
                <a>
                  <span id='firstBreadcrumb'>
                    <a href={finalPathArray[0]?.href}>
                      {finalPathArray[0]?.breadcrumb.includes('-')
                        ? finalPathArray[0]?.breadcrumb.replaceAll('-', ' ')
                        : finalPathArray[0]?.breadcrumb}
                    </a>

                    {finalPathArray?.length > 2 && (
                      <>
                        <img src={breadcrumbSeparator} height={9} width={5} alt='' />
                        <span
                          //  ref={popUpRef}
                          className={`${styles['dots']}`}
                          onClick={handleDropdown}
                        >
                          {BREADCRUMB}
                        </span>
                      </>
                    )}
                  </span>
                  <img src={breadcrumbSeparator} height={9} width={5} alt='' />
                  <span className={`${styles['current-page-breadcrumb']}`}>
                    {finalPathArray[lastPathIndex]?.breadcrumb.includes('-')
                      ? finalPathArray[lastPathIndex]?.breadcrumb.replaceAll('-', ' ')
                      : finalPathArray[lastPathIndex]?.breadcrumb}
                  </span>
                  {dropdownStatus && (
                    <div className={styles['login-flyover']} style={{ left: dropdownWidth + 'px' }}>
                      {slicedMobArr &&
                        slicedMobArr?.map((eachSegment: any, index: number) => {
                          return (
                            <div key={index}>
                              {eachSegment && (
                                <a href={eachSegment?.href}>
                                  {eachSegment?.breadcrumb?.includes('-')
                                    ? eachSegment?.breadcrumb?.replaceAll('-', ' ')
                                    : eachSegment?.breadcrumb}
                                </a>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  )}
                </a>
              </span>
            )}
          </span>
          {/* Desktop view */}
          <span className={`${styles['link']} d-none d-md-block`}>
            {finalPathArray &&
              finalPathArray.map((eachSegment: any, index: number) => {
                return (
                  <span key={index}>
                    {eachSegment &&
                      (index != finalPathArray?.length - 1 ? (
                        <a href={eachSegment.href}>
                          {eachSegment?.breadcrumb?.includes('-')
                            ? eachSegment?.breadcrumb?.replaceAll('-', ' ')
                            : eachSegment?.breadcrumb}
                          <img src={breadcrumbSeparator} height={9} width={5} alt='breadcrumbSeparator'/>
                        </a>
                      ) : (
                        <span className={`${styles['current-page-breadcrumb']}`}>
                          {eachSegment?.breadcrumb?.includes('-')
                            ? eachSegment?.breadcrumb?.replaceAll('-', ' ')
                            : eachSegment?.breadcrumb}
                        </span>
                      ))}
                  </span>
                );
              })}
          </span>
        </div>
      </Row>
    </div>
  );
};

export default Breadcrumb;
